export default {
    baseUrl: "https://api.cd-systeme.com"
};